import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../http-client/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    return this.checkLogin(url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  checkLogin(url: string): boolean {
    // if (this.authService.isAuthenticated()) { return true; }

    // // Store the attempted URL for redirecting
    // //this.authService.redirectUrl = url;

    // // Navigate to the login page with extras
    // this.authService.redirectToDaimler("login");
    // return false;
    if(this.authService.isAuthenticated()) { return true; }
    else{
        // this.router.navigate(['/logout']);
        this.authService.redirectToDaimler('login');
    }
    return true;
  }
}
